import React, { useContext, useMemo } from 'react';
import MapContext from '../../hooks/MapContext';

const MapInteractive = () => {
  const { geojson, year } = useContext(MapContext);

  const n = useMemo(() => {
    if (geojson.length === 0) return 0;
    return geojson.features
      .map((f) => f.properties.regulation)
      .filter((r) => r.length > 0)
      .map((r) => r.map((s) => s.year).filter((y) => y <= year))
      .filter((l) => l.length > 0).length;
  }, [geojson, year]);

  return (
    <span>
      โดยในปี <b style={{ fontSize: 25 }}>{year}</b> มี{' '}
      <b style={{ fontSize: 25 }}>{n}</b> ได้มีการจัดการถุงพลาสติกภายในประเทศ
    </span>
  );
};

export default MapInteractive;
